import React, { Component } from "react";
import '../Styles/Contact.css';

export default class Contact extends Component {
  render() {
    return (
      <section 
        className="contact" 
        id="contact"
      >
        <div className="contact-container" 
          data-aos="fade-up" 
          data-aos-duration="1000"
        >
          <h1 className="title-contact">
            Me envie uma mensagem!
          </h1>
          <div className="contact-content">
            <form 
              action="https://formsubmit.co/23438afbbb97f33ab931e467dc7a2b8a"
              method="POST"
            >
              <input
                type="text"
                name="name"
                className="name-contact"
                placeholder="Digite seu nome!"
                required
              />

              <input
                type="email"
                name="email"
                className="email-contact"
                placeholder="Digite seu email!"
                required
              />

              <textarea
                type="text"
                name="message"
                className="message-contact"
                placeholder="Digite sua mensagem!"
                required
              />

              <div className="contact-buttons">
                <button
                  type="submit"
                  className="submit-message"
                >
                  Enviar
                </button>

                <button
                  type="reset"
                  className="clear-message"
                >
                  Limpar
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    )
  }
}